import { render, staticRenderFns } from "./PipView.vue?vue&type=template&id=12f6d40f&"
import script from "./PipView.vue?vue&type=script&lang=js&"
export * from "./PipView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports